'use client';

import { useEffect, useState } from 'react';

interface Props {
  words: string[];
  stepMs?: number;
  holdMs?: number;
  className?: string;
}

const WORD_SEPARATOR = '\n';

export default function TypewriterCycle({ words, stepMs = 100, holdMs = 1000, className }: Props) {
  const [text, setText] = useState(words[0] ?? '');
  const [paused, setPaused] = useState(true);
  const wordsKey = words.join(WORD_SEPARATOR);

  useEffect(() => {
    const list = wordsKey.split(WORD_SEPARATOR);
    let wordIndex = 0;
    let length = list[0].length;
    let timeoutId = 0;

    const erase = () => {
      length -= 1;
      setText(list[wordIndex].slice(0, length));
      if (length > 0) {
        timeoutId = window.setTimeout(erase, stepMs);
        return;
      }
      wordIndex = (wordIndex + 1) % list.length;
      timeoutId = window.setTimeout(type, stepMs);
    };

    const type = () => {
      length += 1;
      setText(list[wordIndex].slice(0, length));
      if (length < list[wordIndex].length) {
        timeoutId = window.setTimeout(type, stepMs);
        return;
      }
      setPaused(false);
      timeoutId = window.setTimeout(startErasing, holdMs);
    };

    const startErasing = () => {
      setPaused(true);
      timeoutId = window.setTimeout(length > 0 ? erase : type, stepMs);
    };

    setText(list[0]);
    setPaused(true);
    timeoutId = window.setTimeout(startErasing, holdMs);

    return () => window.clearTimeout(timeoutId);
  }, [wordsKey, stepMs, holdMs]);

  const classes = `typewriter-container${paused ? ' pause' : ''}${className ? ` ${className}` : ''}`;

  return <span className={classes}>{text}</span>;
}
